import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {useRecoilState} from 'recoil';
import Config from '../../core/config';
import {loadingAtom} from '../../atoms';
import {makeRequest} from '../../utils/httpRequest';
import {UserPermission, CompanyPermission} from '../../utils/utils';
import {usePermission} from '../../core/PermissionContext';
import Loading from '../../core/Loading';
import ActionButtonsManagerView from '../common/ActionButtonsManagerView';
import ConfirmButton from '../common/ConfirmButton';
import BackButton from '../common/BackButton';

const apiUrl = Config.apiUrl;

const blockClipboard = (event) => {
    event.preventDefault();
};

const ChangePassword = () => {
    const navigate = useNavigate();
    const {hasUserPermission, hasCompanyPermission, loadingPermissions} = usePermission();
    const [, setLoading] = useRecoilState(loadingAtom);

    const isAdminPath = window.location.pathname.startsWith('/admin');
    const basePath = isAdminPath ? '/admin' : '/app';

    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    const canChangePassword =
        hasUserPermission(UserPermission.CHANGE_OWN_PASSWORD) &&
        hasCompanyPermission(CompanyPermission.CHANGE_OWN_PASSWORD);

    if (loadingPermissions) {
        return <Loading/>;
    }

    if (!canChangePassword) {
        navigate('/unauthorizedaccess');
        return null;
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        setErrorMessage('');
        setSuccessMessage('');

        if (!currentPassword || !newPassword || !confirmPassword) {
            setErrorMessage('Preencha todos os campos.');
            return;
        }

        if (newPassword !== confirmPassword) {
            setErrorMessage('A confirmação da nova senha não confere.');
            return;
        }

        if (newPassword === currentPassword) {
            setErrorMessage('A nova senha deve ser diferente da senha atual.');
            return;
        }

        try {
            setLoading(true);
            const response = await makeRequest(
                `${apiUrl}/api/users/change-password`,
                'POST',
                {'Content-Type': 'application/json'},
                JSON.stringify({
                    currentPassword,
                    newPassword,
                    confirmPassword,
                }),
            );

            if (typeof response === 'string') {
                setSuccessMessage(response);
            } else if (response?.message) {
                setSuccessMessage(response.message);
            } else {
                setSuccessMessage('Senha alterada com sucesso.');
            }

            setCurrentPassword('');
            setNewPassword('');
            setConfirmPassword('');
        } catch (error) {
            setErrorMessage(error?.message || 'Não foi possível alterar a senha.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="app-form-page app-form-page--narrow">
            <div className="header-label">Alterar senha</div>

            <form onSubmit={handleSubmit} style={{marginTop: '16px', display: 'flex', flexDirection: 'column', gap: '12px'}}>
                <div>
                    <label htmlFor="current-password">Senha atual</label>
                    <input
                        id="current-password"
                        type="password"
                        autoComplete="current-password"
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                        style={{width: '100%', marginTop: '4px'}}
                    />
                </div>

                <div>
                    <label htmlFor="new-password">Nova senha</label>
                    <input
                        id="new-password"
                        type="password"
                        autoComplete="new-password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        style={{width: '100%', marginTop: '4px'}}
                    />
                </div>

                <div>
                    <label htmlFor="confirm-password">Confirmar nova senha</label>
                    <input
                        id="confirm-password"
                        type="password"
                        autoComplete="new-password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        onPaste={blockClipboard}
                        onCopy={blockClipboard}
                        onCut={blockClipboard}
                        onDrop={blockClipboard}
                        onContextMenu={blockClipboard}
                        style={{width: '100%', marginTop: '4px'}}
                    />
                </div>

                {errorMessage && (
                    <div style={{color: 'var(--alert-overdue-text, #c0392b)'}}>{errorMessage}</div>
                )}
                {successMessage && (
                    <div style={{color: 'var(--alert-success-text, #2e7d32)'}}>{successMessage}</div>
                )}

                <ActionButtonsManagerView>
                    <BackButton onClick={() => navigate(basePath)}/>
                    <ConfirmButton type="submit" title="Salvar nova senha"/>
                </ActionButtonsManagerView>
            </form>
        </div>
    );
};

export default ChangePassword;
